/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getQueuesResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPracticeNewRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskPracticeNewRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDeskQueuesCreateView, {
	LazyServicedeskQueuesCreateView,
} from './ui/create-view/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskPracticeNewRouteEntry: Route = createEntry(
	servicedeskPracticeNewRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskQueuesCreateView,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [...getQueuesResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesCreateView],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
